export const LifetimeHealthCoverSituation = Object.freeze({
  CITIZEN: 'OSE',
  MIGRANT: 'IMM',
  EX_ADF: 'ADF',
  TEN_YEAR_PHI: 'YEA',
  NONE: 'NONE',
});

export default LifetimeHealthCoverSituation;
